<template>
  <div>
    <b-container>
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(next)" autocomplete="off">
          <b-card>
            <template #header>
              <h6 class="mb-0">Declaración de Asegurabilidad</h6>
            </template>

            <p class="text-muted small mb-3">
              Marque SI o NO en cada declaración.
            </p>

            <!-- Declaración 1 -->
            <b-form-group class="declaracion-item">
              <div class="declaracion-fila">
                <span class="declaracion-numero">1.</span>
                <span class="declaracion-texto">
                  Tanto mis actividades como ocupación son lícitas y en consecuencia
                  los bienes que poseo provienen de medios lícitos. Igualmente declaro
                  que no he sido objeto de amenazas, de secuestro o muerte ni me han
                  solicitado contribuciones para evitarlo.
                </span>
                <div class="declaracion-radios">
                  <RadioComponent
                    :form="form"
                    name="declaracion1"
                    :options="control.TIPOS_SINO"
                    rules="required"
                  />
                </div>
              </div>
            </b-form-group>

            <!-- Declaración 2 -->
            <b-form-group class="declaracion-item">
              <div class="declaracion-fila">
                <span class="declaracion-numero">2.</span>
                <span class="declaracion-texto">
                  Autorizo permanente e irrevocablemente a PAN AMERICAN LIFE DE
                  COLOMBIA COMPAÑÍA DE SEGUROS S.A., para que a partir de la fecha
                  procese, conserve o actualice cualquier información de carácter
                  financiero o comercial y la autorizo para que reporte, consulte o
                  suministre esta información a las centrales de información o bases
                  de datos debidamente constituidas, en los términos y durante el
                  tiempo que la ley lo establezca.
                </span>
                <div class="declaracion-radios">
                  <RadioComponent
                    :form="form"
                    name="declaracion2"
                    :options="control.TIPOS_SINO"
                    rules="required"
                  />
                </div>
              </div>
            </b-form-group>

            <!-- Declaración 3 -->
            <b-form-group class="declaracion-item">
              <div class="declaracion-fila">
                <span class="declaracion-numero">3.</span>
                <span class="declaracion-texto">
                  Autorizo expresamente, aún después de mi fallecimiento, a los
                  médicos e instituciones de salud a proporcionar a los Beneficiarios
                  de este seguro y a PAN AMERICAN LIFE DE COLOMBIA COMPAÑÍA DE
                  SEGUROS S.A., copia de mi historia médica clínica, resultados de
                  medios diagnósticos y cualquier información o registro que hayan
                  efectuado o efectúen. En consecuencia renuncio en mi propio nombre
                  y en el de cualquier tercero interesado, a todas las disposiciones
                  de ley que prohíban a los médicos, centros asistenciales o de
                  diagnóstico que me hayan atendido, revelar cualquier información
                  adquirida con motivo de diagnóstico o tratamiento.
                </span>
                <div class="declaracion-radios">
                  <RadioComponent
                    :form="form"
                    name="declaracion3"
                    :options="control.TIPOS_SINO"
                    rules="required"
                  />
                </div>
              </div>
            </b-form-group>

            <!-- Declaración 4 -->
            <b-form-group class="declaracion-item">
              <div class="declaracion-fila">
                <span class="declaracion-numero">4.</span>
                <span class="declaracion-texto">
                  He sido advertido de mi obligación de declarar sinceramente mi
                  estado de salud y cualquier diagnóstico, tratamiento, patología que
                  tenga o haya tenido y las consecuencias de tal omisión, por lo cual
                  manifiesto que todas las declaraciones efectuadas en esta solicitud
                  son completas y verídicas. Acepto que PAN AMERICAN LIFE DE COLOMBIA
                  COMPAÑÍA DE SEGUROS S.A., se reserva los derechos que puedan
                  asistirle en caso que antes o después de mi fallecimiento, se
                  compruebe que esta declaración no corresponde a la realidad
                  (Artículos 1058, 1158 y 1161 del Código de Comercio).
                </span>
                <div class="declaracion-radios">
                  <RadioComponent
                    :form="form"
                    name="declaracion4"
                    :options="control.TIPOS_SINO"
                    rules="required"
                  />
                </div>
              </div>
            </b-form-group>

            <!-- Declaración 5 -->
            <b-form-group class="declaracion-item">
              <div class="declaracion-fila">
                <span class="declaracion-numero">5.</span>
                <span class="declaracion-texto">
                  He leído, revisado, entendido y recibido todas y cada una de las
                  condiciones, del anverso y reverso, del presente certificado, que
                  conozco su contenido, cuáles son mis deberes, obligaciones,
                  derechos, los costos y gastos que le son inherentes y sus
                  consecuencias legales y con mi firma acepto integralmente su
                  contenido.
                </span>
                <div class="declaracion-radios">
                  <RadioComponent
                    :form="form"
                    name="declaracion5"
                    :options="control.TIPOS_SINO"
                    rules="required"
                  />
                </div>
              </div>
            </b-form-group>

            <!-- Declaración 6 -->
            <b-form-group class="declaracion-item">
              <div class="declaracion-fila">
                <span class="declaracion-numero">6.</span>
                <span class="declaracion-texto">
                  Que conozco y puedo acceder al Manual de Políticas de Datos
                  Personales de la Compañía y al aviso de privacidad en www.palig.com
                </span>
                <div class="declaracion-radios">
                  <RadioComponent
                    :form="form"
                    name="declaracion6"
                    :options="control.TIPOS_SINO"
                    rules="required"
                  />
                </div>
              </div>
            </b-form-group>

            <b-row align-h="end" class="mt-4">
              <b-col cols="12" md="4" class="d-flex justify-content-end">
                <b-button @click="previous" variant="secondary" class="mr-2">
                  Anterior
                </b-button>
                <b-button type="submit" variant="primary">
                  Firmar
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-form>
      </validation-observer>
    </b-container>
  </div>
</template>

<script>
import RadioComponent from "@/components/controls/RadioComponent.vue";
import { TIPOS_SINO } from "../../../data/colombia/Selects";

export default {
  name: "FormColombia04",
  components: { RadioComponent },
  data() {
    return {
      form: {},
      control: { TIPOS_SINO },
    };
  },
  mounted() {
    this.$store.dispatch("app/loading", true);
    const { form } = this.$store.state.wizard;
    if (form === undefined || form === null || form === "") {
      this.$router.push("/form/colombia/");
      return;
    }
    this.form = form;
    if (Array.isArray(form.declaraciones) && form.declaraciones.length >= 6) {
      this.form.declaracion1 = form.declaraciones[0] ?? "";
      this.form.declaracion2 = form.declaraciones[1] ?? "";
      this.form.declaracion3 = form.declaraciones[2] ?? "";
      this.form.declaracion4 = form.declaraciones[3] ?? "";
      this.form.declaracion5 = form.declaraciones[4] ?? "";
      this.form.declaracion6 = form.declaraciones[5] ?? "";
    }
    this.$store.dispatch("app/loading", false);
  },
  methods: {
    previous() {
      this.$store
        .dispatch("wizard/save", { index: 3, form: this.form })
        .then(() => this.$router.push("/form/colombia-3.html"));
    },
    next() {
      const todasSi =
        this.form.declaracion1 === "S" &&
        this.form.declaracion2 === "S" &&
        this.form.declaracion3 === "S" &&
        this.form.declaracion4 === "S";
      if (!todasSi) {
        this.$bvToast.toast("Debe responder SI en las declaraciones 1 a 4.", {
          title: "Validación",
          variant: "warning",
          solid: true,
        });
        return;
      }
      if (this.form.declaracion5 !== "S" || this.form.declaracion6 !== "S") {
        this.$bvToast.toast("Debe responder SI en las declaraciones 5 y 6.", {
          title: "Validación",
          variant: "warning",
          solid: true,
        });
        return;
      }
      this.form.declaraciones = [
        this.form.declaracion1,
        this.form.declaracion2,
        this.form.declaracion3,
        this.form.declaracion4,
        this.form.declaracion5,
        this.form.declaracion6,
      ];
      this.$store
        .dispatch("wizard/save", { index: 4, form: this.form })
        .then(() => this.$router.push("/form/colombia-5.html"));
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 1600px;
}
.declaracion-item {
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
}
.declaracion-item:last-of-type {
  border-bottom: none;
}
.declaracion-fila {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
}
.declaracion-numero {
  font-weight: bold;
  flex-shrink: 0;
}
.declaracion-texto {
  flex: 1;
  min-width: 0;
  font-size: 0.95rem;
  text-align: justify;
}
.declaracion-radios {
  flex-shrink: 0;
  white-space: nowrap;
  margin-left: 1rem;
}
</style>
